<template>
    <a v-if="tagTitle" v-bind:href="href" target='_blank' class="text-center inline col-4">
        <b-card v-if="tagTitle">
            <blockquote class="blockquote mb-0">{{tagTitle}}</blockquote>
        </b-card>
    </a>


</template>

<script>
    export default {
        name: 'TagComponent',
        props: {
            href: String,
            tagTitle: String,
            description: String
        }
    }
</script>

<style scoped>
    .card{
        display:inline-block;
        color: #004085;
    }

</style>
